import { authClient } from "./client.js";

// 1.D.3 useSession-wrapper.
//
// Better-Auth:n React-client:n useSession palauttaa { data, isPending, error }.
// Lisataan johdettuja kenttia jotta useimmat callerit eivat tarvitse
// kasitella null-tarkistuksia eri kohdissa.

export type UserSummary = {
  id: string;
  email: string;
  name: string;
};

export type SessionView = {
  isPending: boolean;
  isLoggedIn: boolean;
  user: UserSummary | null;
  error: unknown;
};

/**
 * Johtaa naekymakerros-tason esitysmuodon Better-Auth -sessiosta.
 * Ei riipu DOM:ista — bisneslogiikka voidaan unit-testata.
 */
export function deriveSession(raw: {
  data: { user?: { id: string; email: string; name: string } | null } | null | undefined;
  isPending: boolean;
  error: unknown;
}): SessionView {
  const user = raw.data?.user
    ? { id: raw.data.user.id, email: raw.data.user.email, name: raw.data.user.name }
    : null;
  return {
    isPending: raw.isPending,
    isLoggedIn: !!user,
    user,
    error: raw.error,
  };
}

export function useSession(): SessionView {
  const raw = authClient.useSession();
  return deriveSession(raw);
}

export async function signOut(): Promise<void> {
  await authClient.signOut();
}
